export default __webpack_public_path__ + "static/media/MIM.722cde03.png";